import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { ClientAccount } from 'gql/graphql';
import { gql } from 'graphql-request';
import { TGenericError } from 'types/TGenericError';
import clientUtil from 'utils/clientUtil';

type TData = Pick<ClientAccount, 'id' | 'allowedToHaveEditors'>;

export const useClientAdmin = (
  options: Omit<UseQueryOptions<unknown, TGenericError, TData>, 'queryKey'> = {}
) => {
  const client = clientUtil();

  const graphql = gql`
    query clientAccount {
      clientAccount {
        id
        allowedToHaveEditors
      }
    }
  `;

  return useQuery<unknown, TGenericError, TData>({
    ...options,
    queryKey: ['useClientAdmin'],
    queryFn: async () =>
      client.request<unknown, TData>({
        data: {
          gql: graphql
        }
      })
  });
};
